import Vue from "vue";
import { mapGetters } from "vuex";
import { LoadingSpinner, PartDetailsLink } from "@/components";
import { IPartDetailRelatedPartItem } from "@/types";
import { PartDetailServices } from "@/services";
import { themeHelper }     from "@/components/mixins/themeHelper";

export default Vue.extend({
    name: "RelatedItemsTab",
    mixins: [themeHelper],
    components: { PartDetailsLink, LoadingSpinner },
    computed: {
        ...mapGetters(["getContentItem"]),
    },

    props: {
        relatedParts: {
            type: Array,
            default: () => [],
        },
    },
    created() {
        this.getRelatedPartImages();
    },
    methods: {
        navigateToPart(relatedPartNumber: string) {
            this.$router.push({ name: "PartDetails", query: { oemPartCode: relatedPartNumber } });
        },
        async getRelatedPartImages() {
            var self = this;
            this.relatedParts.forEach(function (relatedPart: any, index: any) {
                self.getRelatedPartImage(relatedPart, index);
            })
        },

        async getRelatedPartImage(part: any, index: any) {

            const params = {
                oemId: "",
                height: 50,
                width: 50,
                copyRight: "None",
                getPublicImagesOnly: "True",
                partId: part.RelatedPartId
            };

            const imagesData = await PartDetailServices.getPartImages(params)
            if (imagesData && imagesData[0] && imagesData[0] != "NoImageAvailable") {
                this.relatedParts[index].ImageUrl = imagesData[0];
            }
            else {
                this.relatedParts[index].ImageUrl = this.getImage("partNoImageAvailable");;
            }
        },
    },
});
